/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "গতকাল",
        "-2": "গত পরশু",
        "0": "আজ",
        "1": "আগামীকাল",
        "2": "আগামী পরশু",
        "future": {
          "one": "{0} দিনের মধ্যে",
          "other": "{0} দিনের মধ্যে"
        },
        "past": {
          "one": "{0} দিন আগে",
          "other": "{0} দিন আগে"
        }
      },
      "day-narrow": {
        "-1": "গতকাল",
        "-2": "গত পরশু",
        "0": "আজ",
        "1": "আগামীকাল",
        "2": "আগামী পরশু",
        "future": {
          "one": "{0} দিনের মধ্যে",
          "other": "{0} দিনের মধ্যে"
        },
        "past": {
          "one": "{0} দিন আগে",
          "other": "{0} দিন আগে"
        }
      },
      "day-short": {
        "-1": "গতকাল",
        "-2": "গত পরশু",
        "0": "আজ",
        "1": "আগামীকাল",
        "2": "আগামী পরশু",
        "future": {
          "one": "{0} দিনের মধ্যে",
          "other": "{0} দিনের মধ্যে"
        },
        "past": {
          "one": "{0} দিন আগে",
          "other": "{0} দিন আগে"
        }
      },
      "hour": {
        "0": "এই ঘণ্টায়",
        "future": {
          "one": "{0} ঘন্টায়",
          "other": "{0} ঘন্টায়"
        },
        "past": {
          "one": "{0} ঘন্টা আগে",
          "other": "{0} ঘন্টা আগে"
        }
      },
      "hour-narrow": {
        "0": "এই ঘণ্টায়",
        "future": {
          "one": "{0} ঘন্টায়",
          "other": "{0} ঘন্টায়"
        },
        "past": {
          "one": "{0} ঘন্টা আগে",
          "other": "{0} ঘন্টা আগে"
        }
      },
      "hour-short": {
        "0": "এই ঘণ্টায়",
        "future": {
          "one": "{0} ঘন্টায়",
          "other": "{0} ঘন্টায়"
        },
        "past": {
          "one": "{0} ঘন্টা আগে",
          "other": "{0} ঘন্টা আগে"
        }
      },
      "minute": {
        "0": "এই মিনিট",
        "future": {
          "one": "{0} মিনিটে",
          "other": "{0} মিনিটে"
        },
        "past": {
          "one": "{0} মিনিট আগে",
          "other": "{0} মিনিট আগে"
        }
      },
      "minute-narrow": {
        "0": "এই মিনিট",
        "future": {
          "one": "{0} মিনিটে",
          "other": "{0} মিনিটে"
        },
        "past": {
          "one": "{0} মিনিট আগে",
          "other": "{0} মিনিট আগে"
        }
      },
      "minute-short": {
        "0": "এই মিনিট",
        "future": {
          "one": "{0} মিনিটে",
          "other": "{0} মিনিটে"
        },
        "past": {
          "one": "{0} মিনিট আগে",
          "other": "{0} মিনিট আগে"
        }
      },
      "month": {
        "-1": "গত মাস",
        "0": "এই মাস",
        "1": "পরের মাস",
        "future": {
          "one": "{0} মাসে",
          "other": "{0} মাসে"
        },
        "past": {
          "one": "{0} মাস আগে",
          "other": "{0} মাস আগে"
        }
      },
      "month-narrow": {
        "-1": "গত মাস",
        "0": "এই মাস",
        "1": "পরের মাস",
        "future": {
          "one": "{0} মাসে",
          "other": "{0} মাসে"
        },
        "past": {
          "one": "{0} মাস আগে",
          "other": "{0} মাস আগে"
        }
      },
      "month-short": {
        "-1": "গত মাস",
        "0": "এই মাস",
        "1": "পরের মাস",
        "future": {
          "one": "{0} মাসে",
          "other": "{0} মাসে"
        },
        "past": {
          "one": "{0} মাস আগে",
          "other": "{0} মাস আগে"
        }
      },
      "nu": ["beng"],
      "quarter": {
        "-1": "গত ত্রৈমাসিক",
        "0": "এই ত্রৈমাসিক",
        "1": "পরের ত্রৈমাসিক",
        "future": {
          "one": "{0} ত্রৈমাসিকে",
          "other": "{0} ত্রৈমাসিকে"
        },
        "past": {
          "one": "{0} ত্রৈমাসিক আগে",
          "other": "{0} ত্রৈমাসিক আগে"
        }
      },
      "quarter-narrow": {
        "-1": "গত ত্রৈমাসিক",
        "0": "এই ত্রৈমাসিক",
        "1": "পরের ত্রৈমাসিক",
        "future": {
          "one": "{0} ত্রৈমাসিকে",
          "other": "{0} ত্রৈমাসিকে"
        },
        "past": {
          "one": "{0} ত্রৈমাসিক আগে",
          "other": "{0} ত্রৈমাসিক আগে"
        }
      },
      "quarter-short": {
        "-1": "গত ত্রৈমাসিক",
        "0": "এই ত্রৈমাসিক",
        "1": "পরের ত্রৈমাসিক",
        "future": {
          "one": "{0} ত্রৈমাসিকে",
          "other": "{0} ত্রৈমাসিকে"
        },
        "past": {
          "one": "{0} ত্রৈমাসিক আগে",
          "other": "{0} ত্রৈমাসিক আগে"
        }
      },
      "second": {
        "0": "এখন",
        "future": {
          "one": "{0} সেকেন্ডে",
          "other": "{0} সেকেন্ডে"
        },
        "past": {
          "one": "{0} সেকেন্ড পূর্বে",
          "other": "{0} সেকেন্ড পূর্বে"
        }
      },
      "second-narrow": {
        "0": "এখন",
        "future": {
          "one": "{0} সেকেন্ডে",
          "other": "{0} সেকেন্ডে"
        },
        "past": {
          "one": "{0} সেকেন্ড আগে",
          "other": "{0} সেকেন্ড আগে"
        }
      },
      "second-short": {
        "0": "এখন",
        "future": {
          "one": "{0} সেকেন্ডে",
          "other": "{0} সেকেন্ডে"
        },
        "past": {
          "one": "{0} সেকেন্ড পূর্বে",
          "other": "{0} সেকেন্ড পূর্বে"
        }
      },
      "week": {
        "-1": "গত সপ্তাহ",
        "0": "এই সপ্তাহ",
        "1": "পরের সপ্তাহ",
        "future": {
          "one": "{0} সপ্তাহে",
          "other": "{0} সপ্তাহে"
        },
        "past": {
          "one": "{0} সপ্তাহ আগে",
          "other": "{0} সপ্তাহ আগে"
        }
      },
      "week-narrow": {
        "-1": "গত সপ্তাহ",
        "0": "এই সপ্তাহ",
        "1": "পরের সপ্তাহ",
        "future": {
          "one": "{0} সপ্তাহে",
          "other": "{0} সপ্তাহে"
        },
        "past": {
          "one": "{0} সপ্তাহ আগে",
          "other": "{0} সপ্তাহ আগে"
        }
      },
      "week-short": {
        "-1": "গত সপ্তাহ",
        "0": "এই সপ্তাহ",
        "1": "পরের সপ্তাহ",
        "future": {
          "one": "{0} সপ্তাহে",
          "other": "{0} সপ্তাহে"
        },
        "past": {
          "one": "{0} সপ্তাহ আগে",
          "other": "{0} সপ্তাহ আগে"
        }
      },
      "year": {
        "-1": "গত বছর",
        "0": "এই বছর",
        "1": "পরের বছর",
        "future": {
          "one": "{0} বছরে",
          "other": "{0} বছরে"
        },
        "past": {
          "one": "{0} বছর পূর্বে",
          "other": "{0} বছর পূর্বে"
        }
      },
      "year-narrow": {
        "-1": "গত বছর",
        "0": "এই বছর",
        "1": "পরের বছর",
        "future": {
          "one": "{0} বছরে",
          "other": "{0} বছরে"
        },
        "past": {
          "one": "{0} বছর পূর্বে",
          "other": "{0} বছর পূর্বে"
        }
      },
      "year-short": {
        "-1": "গত বছর",
        "0": "এই বছর",
        "1": "পরের বছর",
        "future": {
          "one": "{0} বছরে",
          "other": "{0} বছরে"
        },
        "past": {
          "one": "{0} বছর পূর্বে",
          "other": "{0} বছর পূর্বে"
        }
      }
    },
    "locale": "bn"
  });
}